import { postApi } from "../components/Utility";

import { action, makeObservable, observable } from "mobx";

class FuelDetailsStore {
  fuelDetail = [];
  // users=[]
  // drivers=[]
  // staff=[]
  // passengers=[]
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      fuelDetail: observable,
      total: observable,
      loading: observable,
      loadData: action,
      addData: action,
      getFuelDetails: action,
      deleteRecord: action,
      exportExcel: action,
      checkCompany: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId }) {
    this.loading = true;
    console.log("fuel Details");
    const params = { companyId: companyId, offset: 0, limit: 15, page: 1 };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("FuelDetails/getFuelDetails", { params: params });
    // var postData = { companyId: companyId, offset: 0, limit: 15, page: 1 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=fuel&a=getFueldetails", "postData=" + base64Input);
    // console.log("fuel detis ", response?.data?.data);
    this.fuelDetail = response?.data?.data;
    // //  this.setCompanies(response?.data?.data?.companydata);
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async addData(postData) {
    console.log(postData);
    // var postData = values;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=fuel&a=update", "postData=" + base64Input);
    // console.log(response);
    var fuelData = { postData };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("FuelDetails/saveFuelDetailsData", fuelData);
    return response.data;
  }

  async getFuelDetails({ fuelId, offset, limit }) {
    // var postData = { fuelId: fuelId, offset: 0, limit: 1 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=fuel&a=getFueldetails", "postData=" + base64Input);
    // console.log(response);

    const params = { fuelId, limit: 1, offset: 0 };
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("FuelDetails/getFuelDetails", {
        params: params,
      });
    return response.data.data[0];
  }

  async deleteRecord({ fuelId }) {
    // var postData =  {"tokenId":"","FuelDetails":{"fuelId":fuelId}}
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi.getClient().post("index.php?c=fuel&a=delete", "postData=" + base64Input);
    // console.log(response)

    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("FuelDetails/deleteFuelDetails", {
        params: {
          fuelId: fuelId,
        },
      });
    return response;
  }

  async exportExcel(postData) {
    // console.log(postData);
    try {
      var response = await postApi
        .getClient("NodeCoreUrl")
        .post("FuelDetails/exportFuelDetailsExcel", postData, {
          responseType: "blob",
        });
      // console.log(response, "response");
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Fuel Details Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  // async exportExcel(getData) {
  //   window.location.href =
  //     config.baseURL +
  //     "index.php?c=fuel&a=fueldetailsExportexcel&cid=" +
  //     getData.cid +
  //     "&colList=" +
  //     getData.colList;
  // }

  async checkCompany(postData) {
    console.log(postData);
    // var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=fuel&a=checkFuel", "postData=" + base64Input);
    // var response = await postApi
    //   .getClient("NodeCoreUrl")
    //   .post("FuelDetails/checkCompany", {
    //     params: data,
    //   });

    var fuelData = { postData };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("FuelDetails/checkCompany", fuelData);
    return response.data.data;
  }
}

export default FuelDetailsStore;
